/** Class-name joiner. Small enough not to justify a dependency, used by every primitive. */
export function cx(...values: (string | false | null | undefined)[]): string {
  return values.filter(Boolean).join(" ");
}
